import { render, staticRenderFns } from "./LicenseUserMessages.vue?vue&type=template&id=503bb1fe&scoped=true&"
import script from "./LicenseUserMessages.vue?vue&type=script&lang=js&"
export * from "./LicenseUserMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503bb1fe",
  null
  
)

export default component.exports